export default __webpack_public_path__ + "1bc74bdbeffb8945d78f39017ed5288e.png";